import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header";

const getPaymentDetails = (state) => {
   return axios.get(API +"contracts/paymentDetail-view/"+state+"/",{headers: authHeader(),});
};
const ViewPaymentService = {
    getPaymentDetails,
  };
  export default ViewPaymentService;